import { useTranslation, Trans } from 'react-i18next';

export const NewFreeReminderTemplate = () => {
  const { t } = useTranslation();
  const legalLabel = t('PrivateLayout.reminderBodyNewFreeLinks').replace(
    '{{contactURL}}',
    t('PublicFooter.Support.contactURL')
  );
  return (
    <>
      <span>{t('PrivateLayout.reminderBodyNewFree')} </span>
      <br />
      <Trans
        components={
          // eslint-disable-next-line
          { a: <a /> }
        }
      >
        {legalLabel}
      </Trans>
    </>
  );
};
